import { types } from "../../constants";
import { AccountApplicableFilters } from "../../hooks/use-event";
import { FilterOption } from "../Filter";

export function filterEventTypes(
  alerts: boolean,
  applicableFilters?: AccountApplicableFilters
): FilterOption[] {
  if (!applicableFilters) {
    return [];
  }

  return types.filter((type) => {
    if (
      type.value === "HYPERLAPSE" &&
      (!applicableFilters.hasMflCamera || alerts)
    ) {
      return false;
    }
    if (alerts && type.value === "VOD") {
      return false;
    }
    if (
      (type.value === "EYE_CLOSE" ||
        type.value === "DRIVER_ABNORMAL" ||
        type.value === "DRIVER_CAMERA_BLOCKED" ||
        type.value === "SMOKING" ||
        type.value === "PHONE_USE") &&
      !applicableFilters.hasAiCamera
    ) {
      return false;
    }
    return true;
  });
}
